import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {MatTab} from '@angular/material/tabs';
import {Notification} from '../interfaces/notification-base.interface';

@Component({
  selector: 'app-notifications-tab',
  templateUrl: './notifications-tab.component.html',
  styleUrls: ['./notifications-tab.component.css']
})
export class NotificationsTabComponent extends MatTab implements OnInit {
  @Input('header') matHeader: string;
  @Input('notifications') notifications: Notification[];
  @Input('badge') matBadge: number;

  constructor(_viewContainerRef: ViewContainerRef) {
    super(_viewContainerRef, null);
  }

  ngOnInit(): void {}
}
